import { Box, Button, Typography } from "@mui/material";
import { CustomCheckBox } from "../../utils/CustomCheckBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ButtonZoom } from "../../utils/ButtonZoom";
import * as React from "react";
import { makeStyles } from "@mui/styles";
import { generateGtmEvent } from "../../../../Helpers";

const useStyles = makeStyles((theme) => ({
  btnContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  pad24: {
    padding: "0px 0px 24px 0px",
  },
  backButton: {
    padding: "0px",
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    width: "90px",
    height: "45px",
    boxShadow: "none",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "90px",
      height: "45px",
      textDecoration: "underline",
      color: theme.palette.text.primary,
      boxShadow: "none",
      transform: "none",
    },
  },
}));

interface StepOneProps {
  handleBack: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleNext: (e: React.MouseEvent<HTMLButtonElement>) => void;
  checkedAccessibility: boolean;
  handleAccessibility: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isDisabled: boolean;
}

export const AccessibilityStep = (props: StepOneProps) => {
  const classes = useStyles();
  const {
    handleBack,
    handleNext,
    checkedAccessibility,
    handleAccessibility,
    isDisabled,
  } = props;
  const HandleDataLayer = (
    event: string,
    action: string,
    name: string,
    type: string,
    region: string,
    section: string,
    text: string
  ) => {
    generateGtmEvent({ event, action, name, type, region, section, text });
  };
  return (
    <div>
      <Typography component="p" variant={"body2"} className={classes.pad24}>
        Turning this on will enable keyboard functionality and higher contrast in the
        problem solving platform.
      </Typography>
      <Box className={classes.pad24}>
        <CustomCheckBox
          label={"Enhance accessibility"}
          checked={checkedAccessibility}
          onChange={(event) => {
            handleAccessibility(event);
          }}
          emitDataLayer={(checked) => {
            HandleDataLayer(
              "select",
              checked ? "click" : "unclick",
              "onclick",
              "checkbox",
              "main content",
              "create your account",
              "Enhance accessibility"
            );
          }}
        />
      </Box>
      <div className={classes.btnContainer}>
        <Button
          size="medium"
          className={classes.backButton}
          variant="contained"
          sx={{ marginLeft: "-0.85em" }}
          startIcon={<ArrowBackIcon style={{ width: "16px", height: "16px" }} />}
          onClick={(e) => {
            HandleDataLayer(
              "link",
              "click",
              "onclick",
              "internal link",
              "main content",
              "create your account",
              "back"
            );
            handleBack(e);
          }}>
          Back
        </Button>
        <ButtonZoom
          sx={{ width: "146px", height: "62px" }}
          disabled={isDisabled}
          type="submit"
          size="large"
          variant="contained"
          color="secondary"
          onClick={(e) => {
            HandleDataLayer(
              "link",
              "click",
              "onclick",
              "internal link",
              "main content",
              "create your account",
              "Continue"
            );
            handleNext(e);
          }}>
          Continue
        </ButtonZoom>
      </div>
    </div>
  );
};
